import { NotificationStyle } from "@/lib/models/notifications";
import { environment } from "@/lib/resources";

// Wird von re-lounge bereitgestellt
declare namespace LiveRegion {
	/**
	 * Updates the global live region with a new message to trigger screen readers.  
	 * Clears and resets the content to ensure the change is announced.  
	 * Returns true if the update was successful, false otherwise.
	 *
	 * can be called from everywhere with:   LiveRegion.update("Nachricht in der Liveregion", "success", 3000);
	 * @param {string} message The message to be announced.
	 * @param {string} style The style of the message, can be 'error', 'info', 'success' or defaults to 'success'.
	 * @param {number} closetime Optional time in milliseconds after which the message should be closed. If not provided or 0, the message will not close automatically.
	 */
	function update(message: string, style: NotificationStyle, closetime?: number | null): boolean;
}

// nur bei Avenit so vorhanden. Die API ist bei ReLounge anders (und deprecated)
declare namespace NotificationLayer {
	function openNotification(messages: string, style: NotificationStyle, duration?: number | null): void;
}

export function showNotification(style: NotificationStyle, message: string, duration: number | undefined | null = 5000) {
	if (environment.inocon) {
		// Avenit interpretiert 0 als "sofort schließen" anstatt "nie schließen"
		if (duration == 0) duration = Number.MAX_SAFE_INTEGER;

		NotificationLayer.openNotification(message, style, duration);
		return;
	}

	LiveRegion.update(message, style, duration);
}

export function clearNotification() {
	// Beide APIs bieten keine Möglichkeit die Notification verfrüht wieder zu schließen
	let closeButton = environment.inocon
		? $(".notification .notification__close")
		: $("#global-live-region .notification__close");

	closeButton.trigger("click");
}

export function getNotificationStatus(istFehler: boolean): NotificationStyle {
	return istFehler ? NotificationStyle.Error : NotificationStyle.Success;
}
